export class UsuariosCargosModel {
  id: number;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/app/usuarios-cargos/usuarios-cargos.model.ts